import ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import { ClientItem, mailStore, ConversationReadingPaneNode } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';

export default function getQuotedTextList(item: ClientItem): string[] {
    const conversationItemId = item.ConversationId.Id;
    const conversationItemParts: ConversationItemParts = mailStore.conversations.get(
        conversationItemId
    );

    if (conversationItemParts?.conversationNodeIds) {
        const messageItem = item as Message;
        let conversationNode: ConversationReadingPaneNode = mailStore.conversationNodes.get(
            messageItem.InternetMessageId
        );

        if (conversationNode?.quotedTextList) {
            return conversationNode.quotedTextList;
        }
    }

    return undefined;
}
